import { Component, OnInit } from '@angular/core';
import { User } from '../../shared/models/user';
import { Role } from '../../shared/models/role';
import { UserService } from '../../shared/services/user.service';
import { RoleService } from '../../shared/services/role.service';

import { FormBuilder, AbstractControl, FormGroup, Validators, ValidationErrors, NG_VALUE_ACCESSOR, FormArray } from '@angular/forms';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

	users: User[] = [];
	roles: Role[] = [];
  	selectedUser: User = new User;
	form: FormGroup;
	selectedRoles: [] = [];

  	constructor(
		  private userService: UserService,
		  private roleService: RoleService,
  		private fb: FormBuilder
  	) { }

  	ngOnInit() {
		this._buildForm();
  		this.userService.getAll('name',2,{},0,20).subscribe(t => {
			  this.users = (t.body);
		});

		this.roleService.getAll().subscribe(t => this.roles = t);
  	}

  	selectUser(id: number) {
  		this.userService.get(id).subscribe(t => {
			this.selectedUser = t;
  			this._buildForm();
  		});
  	}


  	_buildForm() {
 		this.form = this.fb.group({
 			'username': [ this.selectedUser.username, [ Validators.required ] ],
 			'email': [ this.selectedUser.email, [ Validators.required ] ],
 			'lastname': [ this.selectedUser.userProfile.lastname, [ Validators.required ] ],
			'firstname': [ this.selectedUser.userProfile.firstname, [ Validators.required ] ],
			't_hrs':  [this.selectedUser.t_hrs, []],
			't_km':  [this.selectedUser.t_km, []],
            'passwords': this.fb.group({
                    password: ['', []],
                    confirm_password: ['', []],
             }, {validator: this.passwordConfirming}),
			'roles': this.fb.array(this.roles.map(r => {
				return this.fb.group({
					'name': [ r.description || r.name, []],
					'checked': [ (this.selectedUser.roles.findIndex(ur => ur.item_name === r.name ) >= 0) ? true : false , []],
				});
			})),

    	});
  	}

	  getRoles() : FormArray {
		  return <FormArray>this.form.controls.roles;
	  }

 	passwordConfirming(c: AbstractControl): any {
	    if (c.get('password').value !== c.get('confirm_password').value) {
	        return {passwordMismatch:true};
	    }
	}

	save(event) {
		let request = Object.assign({
			id: this.selectedUser.id,
			username: this.form.value.username,
			email: this.form.value.email,
			pass: this.form.value.passwords.password,
			firstname: this.form.value.firstname,
			lastname: this.form.value.lastname,
			t_hrs: this.form.value.t_hrs,
			t_km: this.form.value.t_km,
			roleList: this.form.value.roles.filter(r => r.checked).map(r => r.name),
		});

		this.userService.save(request).subscribe(u => {
			this.users = this.users.filter(lu => lu.id !== u.id).concat(u);
		});
	}

	onCancel() {
	}
}
